export default __webpack_public_path__ + "static/media/architect.6ca70747.png";